import styled from 'styled-components';
import { BP_TABLET_MAX } from '../../../assets/styles/breakpoints';
import { COLOR_DARKER_GREY, COLOR_WHITE } from '../../../assets/styles/colors';

export default styled.div`
  margin-top: 35px;
  height: auto;
  @media (max-width: ${BP_TABLET_MAX}px) {
    margin-top: 20px;
  }

  .body-wrapper {
    background: ${COLOR_WHITE};
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
    .headline-data-wrap {
      display: flex;
      justify-content: space-between;
    }
    .body-data-wrap {
      background: ${COLOR_DARKER_GREY};
      border-radius: 12px;
      padding: 16px 0;
      margin-top: 24px;
      &--item {
        padding: 8px 16px 0px 16px;

        &:first-child {
          padding-top: 0px;
        }

        .document-item-wrap {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 10px 0px;
          border-bottom: 1px solid rgba(47, 46, 65, 0.1);
          cursor: pointer;

          &:hover {
            opacity: 0.8;
          }

          &:first-child {
            padding-top: 0px;
          }

          &:last-child {
            padding-bottom: 0px;
            border-bottom: none;
          }

          .document-name {
            display: inline-block;
            word-break: break-all;
            line-height: initial;
          }

          .document-icon {
            padding-right: 10px;
          }
        }
      }
    }
  }
`;
